import { createFileRoute } from '@tanstack/react-router'
import { internshipDetailsPageSearchSchema } from '@/pages/internships/model/internshipDetailsPageSearch'
import { InternshipDetailsPage } from '@/pages/internships/ui/InternshipDetailsPage'
export const Route = createFileRoute('/internships_/$internshipId')({
  validateSearch: internshipDetailsPageSearchSchema,
  component: Details,
})
function Details() {
  const { internshipId } = Route.useParams()
  return <InternshipDetailsPage internshipId={internshipId} />
}
